import { useAvailabilityPageContainer } from "@tenant/hotels";
import { usePackageHotelAvailabilityPageFetch } from "@tenant/packages";
import type { PackageHotelAvailabilityPageProps } from "../types";

export const usePackageHotelAvailabilityPage = (
  props: PackageHotelAvailabilityPageProps
) => {
  usePackageHotelAvailabilityPageFetch(props);
  return useAvailabilityPageContainer();
};
